import React from 'react'

interface ColumnSelectorProps {
  columns: { key: string; value: string; visible?: boolean }[]
  onChange: (key: string, visible: boolean) => void
  onClose: () => void
}

export const ColumnSelector: React.FC<ColumnSelectorProps> = ({ columns, onChange, onClose }) => {
  return (
    <div className="dropdown-menu show p-4 shadow" style={{ position: 'absolute', top: 40, right: 20, minWidth: 220, zIndex: 1000 }}>
      <div className="d-flex justify-content-between align-items-center mb-2">
        <span className="fw-bold">Colunas visíveis</span>
        <button type="button" className="btn-close" aria-label="Fechar" onClick={onClose}></button>
      </div>
      <ul className="list-unstyled mb-0 gap-4">
        {columns.map((col) => (
          <li key={col.key} className="mb-1">
            <div className="form-check py-1">
              <input
                className="form-check-input"
                type="checkbox"
                id={`col-check-${col.key}`}
                checked={col.visible !== false}
                onChange={(e) => onChange(col.key, e.target.checked)}
              />
              <label className="form-check-label" htmlFor={`col-check-${col.key}`}>
                {col.key}
              </label>
            </div>
          </li>
        ))}
      </ul>
    </div>
  )
}
